import { Component } from 'vue-property-decorator';
import { $router } from '@/main';
import jQuery from 'jquery';
import PageRender from '@/models/PageRender';

@Component
export default class TeamInsightsComponent extends PageRender {
    public tab: string = null;
    public currentTabComponent: string = '';
    public tabs: string[] = ['group-results', 'member-results', 'payment-statusses'];

    public async mounted() {
        await this.checkPeriodParam();
        await this.changeTab(this.$route.params.tab);
    }

    public async changeTab(tab: string): Promise<void> {
        if (tab !== this.$route.params.tab) {
            const params = this.$route.params;
            params.tab = tab;

            await $router.push({ name: 'team-insights', params });
        } else {
            if (this.tabs.indexOf(tab) === -1) {
                tab = this.tabs[0];
            }

            this.doActiveClass(tab);
            this.currentTabComponent = 'team-insights-' + tab;
        }
    }

    public doActiveClass(tab: string) {
        this.$nextTick(() => {
            jQuery('.' + tab).addClass('active');
        });
    }
}
